import {request, serviceUrl} from "@/utils/request";

//根据工作流实例ID获取工作流动作日志数据
export function getLinkageLogsListByActionId(procId) {
  return request({
    url: serviceUrl.deviceService + '/device/linkage-activiti/logs/getActivitiLogListByProcId',
    params:{
      procId
    }
  })
}
